import { OrganizationKeyName } from "../../../model/Organization";
import { AdminErrorListResponseData } from "../../../service/api-response/AdminFormErrorResponse";

export const UPSERT_PRODUCT_FAIL = "SHOP:UPSERT_PRODUCT_FAIL";

export const upsertProductFailAction = (
  organization: OrganizationKeyName,
  errors: AdminErrorListResponseData,
  id?: string
) => ({
  type: UPSERT_PRODUCT_FAIL as typeof UPSERT_PRODUCT_FAIL,
  organization,
  errors,
  id,
});

export type UpsertProductFail = ReturnType<typeof upsertProductFailAction>;
